export default [
	'pages',
	'static-content',
	'post',
	'show',
	'team-member'
];



// WEBPACK FOOTER //
// ./src/post-types/index.js